import { HttpService } from '@/common/services/http.service';

const CarouselService = {
  CAROUSEL_API_HOST: process.env.VUE_APP_ADMIN_HOST,
  CAROUSEL_IMAGE_DIR: 'storage',

  getSlides() {
    return HttpService.httpGet(`${this.CAROUSEL_API_HOST}/api/carousel/slide`)
        .then(slides => slides.map(slide => {
          if (slide.featured_image) {
            return {
              ...slide, ...{featured_image: `${this.CAROUSEL_API_HOST}/${this.CAROUSEL_IMAGE_DIR}/${slide.featured_image}`}
            }
          }

         return slide;
        }));
  }
};

export default CarouselService;
